<template>
    <the-form-layout :init-method="getBasicConfig" :sure-method="updateBasicConfig">
        <template #default="{ data: form }">
            <isc-form-item class="w400" label="企业名称">
                <isc-input v-model="form.enterprise" :disabled="!canEdit" placeholder="请输入企业名称"></isc-input>
            </isc-form-item>
            <isc-form-item class="w400" label="企业联络电话">
                <isc-input v-model="form.phoneNum" :disabled="!canEdit" placeholder="请输入企业联络电话"></isc-input>
            </isc-form-item>
            <isc-form-item class="w400" label="企业描述">
                <isc-input v-model="form.powerby" :disabled="!canEdit" placeholder="请输入企业描述"></isc-input>
            </isc-form-item>
            <isc-form-item label="Logo">
                <!--                <the-upload-logo v-model="form.logo" />-->
                <isc-button plain @click="openAsd">外观设置</isc-button>
            </isc-form-item>

            <the-appearance-settings-dialog ref="asd" />
        </template>
    </the-form-layout>
</template>

<script>
import TheAppearanceSettingsDialog from '../../the-appearance-settings-dialog.vue';
import TheFormLayout from '../components/the-form-layout';
import { getBasicConfig, updateBasicConfig, queryCanEdit } from './service';
import TheUploadLogo from '@/components/desk-header/components/configs/components/the-upload-logo';

export default {
    name: 'BasicConfig',

    components: {
        TheAppearanceSettingsDialog,
        // TheUploadLogo,
        TheFormLayout
    },

    data() {
        return {
            getBasicConfig,
            updateBasicConfig,
            canEdit: false
        };
    },

    created() {
        this.setCanEdit();
    },

    methods: {
        async setCanEdit() {
            try {
                // 传参ids:[0,1] 指标0:能否修改logo
                const res = await queryCanEdit([0]);
                this.canEdit = res[0];
            } catch (err) {
                this.canEdit = false;
            }
        },

        openAsd() {
            this.$refs.asd.open('DesktopConfig');
        }
    }
};
</script>

<style lang="scss" scoped></style>
